// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: window['env']['apiUrl'],
  udfUrl: window['env']['udfUrl'],
  labUrl: window['env']['labUrl'],
  chatUrl: window['env']['chatUrl'],
  muxUrl: window['env']['muxUrl'],
  socketUrl: window['env']['socketUrl'],
  hostUrl: window['env']['hostUrl'],
  keycloakUrl: window['env']['keycloakUrl'],
  keycloakRealm: window['env']['keycloakRealm'],
  keycloakClientId: window['env']['keycloakClientId'],
  litDir: window['env']['litDir'],
  features: window['env']['features'],
  saasMode: window['env']['saasMode'],
  sshExecution: window['env']['sshExecution']
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
